// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.busy-overlay_56936657 {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 80;
  background-color: rgba(0,0,0,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
}
.busy-overlay__light_56936657 {
  background-color: rgba(255,255,255,0.8);
}
.busy-overlay__container_56936657 {
  position: relative;
  max-width: 100vw;
  max-height: 100vh;
}
.busy-overlay__container_56936657 > .message {
  margin: -0.333em;
}
.busy-overlay__container-exit_56936657 {
  opacity: 1;
  filter: "progid:DXImageTransform.Microsoft.Alpha(opacity=100)";
  transform: scale3d(1, 1, 1);
}
.busy-overlay__container-exit-active_56936657 {
  opacity: 0;
  filter: "progid:DXImageTransform.Microsoft.Alpha(opacity=100)";
  transform: scale3d(0.9, 0.9, 1);
  transition: all 300ms ease;
  transition-property: opacity, transform;
}
.busy-overlay__container-enter_56936657 {
  opacity: 0;
  filter: "progid:DXImageTransform.Microsoft.Alpha(opacity=0)";
  transform: scale3d(0.9, 0.9, 1);
}
.busy-overlay__container-enter-active_56936657 {
  opacity: 1;
  filter: "progid:DXImageTransform.Microsoft.Alpha(opacity=100)";
  transform: scale3d(1, 1, 1);
  transition: opacity, transform 300ms ease;
}
.busy-overlay-appear_56936657,
.busy-overlay-enter_56936657 {
  opacity: 0;
}
.busy-overlay-appear-active_56936657,
.busy-overlay-enter-active_56936657 {
  opacity: 1;
  transition: all 300ms ease;
}
.busy-overlay-appear-active_56936657 .busy-overlay__container_56936657,
.busy-overlay-enter-active_56936657 .busy-overlay__container_56936657 {
  transition: all 300ms ease;
}
.busy-overlay-exit_56936657 {
  opacity: 1;
}
.busy-overlay-exit-active_56936657 {
  opacity: 0;
  transition: all 300ms ease;
}
.busy-overlay-exit-active_56936657 .busy-overlay__container_56936657 {
  transition: all 300ms ease;
}
.busy-overlay-exit-done_56936657 {
  opacity: 0;
}
.hide-scrollbar_56936657 {
  scrollbar-width: none;
  overflow: hidden;
}
.hide-scrollbar_56936657::-webkit-scrollbar {
  display: none;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"busy-overlay": `busy-overlay_56936657`,
	"busy-overlay__light": `busy-overlay__light_56936657`,
	"busy-overlay__container": `busy-overlay__container_56936657`,
	"busy-overlay__container-exit": `busy-overlay__container-exit_56936657`,
	"busy-overlay__container-exit-active": `busy-overlay__container-exit-active_56936657`,
	"busy-overlay__container-enter": `busy-overlay__container-enter_56936657`,
	"busy-overlay__container-enter-active": `busy-overlay__container-enter-active_56936657`,
	"busy-overlay-appear": `busy-overlay-appear_56936657`,
	"busy-overlay-enter": `busy-overlay-enter_56936657`,
	"busy-overlay-appear-active": `busy-overlay-appear-active_56936657`,
	"busy-overlay-enter-active": `busy-overlay-enter-active_56936657`,
	"busy-overlay-exit": `busy-overlay-exit_56936657`,
	"busy-overlay-exit-active": `busy-overlay-exit-active_56936657`,
	"busy-overlay-exit-done": `busy-overlay-exit-done_56936657`,
	"hide-scrollbar": `hide-scrollbar_56936657`
};
export default ___CSS_LOADER_EXPORT___;
